import moment from 'moment';
import { persistentKVStore } from '..';
export var setLastInteractionDate = function (key) {
    persistentKVStore.setItem(key, new Date().toISOString());
};
export var didEnoughTimePass = function (key, threshold) {
    var lastInteractionDate = persistentKVStore.getItem(key);
    if (!lastInteractionDate) {
        return true;
    }
    return moment.duration(moment().diff(moment(lastInteractionDate))).asHours() > threshold;
};
export var wasPreviouslyInteracted = function (key) {
    var interactionDate = persistentKVStore.getItem(key);
    return !!interactionDate;
};
